import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { tap, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '../../CoreWeb/Utils/Utils'
import { GlobalSettingsService } from '../../CoreWeb/GlobalSettings/GlobalSettings';
import { ItemsService } from '../../CoreWeb/Grid/ItemsData';
import { ItemClass, SortClass } from '../../CoreWeb/Grid/Models';
import { HttpServerService } from '../../CoreWeb/HttpServer/HttpServer';

@Injectable({providedIn: 'root'})
export class StatisticsTemplatesService extends ItemsService {

    colId: number = this.incColIdx();
    colName: number = this.incColIdx();
    colDescription: number = this.incColIdx();
    colCategory: number = this.incColIdx();
    colDefSettings: number = this.incColIdx();
    colQuery: number = this.incColIdx();
    colIsCustom: number = this.incColIdx();
    
    constructor(public http: HttpServerService, public platform: Platform, public translate: TranslateService,
        public utilsService: UtilsService, public globalSettings: GlobalSettingsService) {
        super();
        // divider in coloana
        this.initColumns([
            ['ID', 'Number', [], (item: ItemClass) => { return item; }, { canFilter: false, canDisplay: false }],
            ['NAME', 'Text', [], (item: ItemClass) => { return item[this.colName]; }],
            ['DESCRIPTION', 'Text', [], (item: ItemClass) => { return item[this.colDescription]; }],
            ['CATEGORY', 'Text', [], (item: ItemClass) => { return item[this.colCategory]; }],
            ['DEF_SETTINGS', 'Text', [], (item: ItemClass) => { return item[this.colDefSettings]; }, { canFilter: false, canDisplay: false }],
            ['QUERY', 'Text', [], (item: ItemClass) => { return item[this.colQuery]; }],
            ['IS_CUSTOM', 'Number', [], (item: ItemClass) => { return item[this.colIsCustom]; }]
        ]);

        this.usersort.push(new SortClass(this.getColumnByName('NAME').id, 1));
        this.lstep = 30;
        this.maxSortColumns = 1;
    }

    refresh() {
        return super.refresh();
    }

    getData(lstart: number, lstep: number, orderC?: string,
        orderT?: string, searchC?: string, searchV?: string, columns?: any) {

        return this.http.postType("Statistics.Templates", "List", {})
            .pipe(
                tap((data) => {
                    let translate = [];
                    for (let i = 0; i < data.length; i++) {
                        if (data[i][this.colDefSettings]) data[i][this.colDefSettings] = JSON.parse(data[i][this.colDefSettings]);
                        if (data[i][this.colQuery]) data[i][this.colQuery] = JSON.parse(data[i][this.colQuery]);
                        data[i].name = data[i][this.colName];
                        data[i].category = data[i][this.colCategory];
                        data[i].query = data[i][this.colQuery]["DB::Query"].Columns;

                        data[i].groups = [];
                        data[i].columns = [];

                        for (let j = 0; j < data[i].query.length; j++) {
                            let column = data[i].query[j]["DB::Column"];
                            translate.push(column.DisplayName);
                            if (column.UsedInGroupBy)
                                data[i].groups.push(column);
                            else if (column.DisplayName && column.DisplayName != "" &&
                                column.ColumnFormula && column.ColumnFormula != "")
                                data[i].columns.push(column);
                        }
                    }

                    this.translate.get(translate).subscribe((tr) => {
                        for (let i = 0; i < data.length; i++) {
                            for (let j = 0; j < data[i].query.length; j++) {
                                let column = data[i].query[j]["DB::Column"];
                                column.DisplayName = tr[column.DisplayName];
                            }
                        }
                    });
                })
            );
    }

    getList() {
        return this.http.postType("Statistics.Templates", "List", {});
    }

    getTemplate(name = "") {
        for (let i = 0; i < this.currentItems.length; i++) {
            if (this.currentItems[i][this.colName] == name || name == "")
                return this.currentItems[i];
        }
        return null;
    }

    add(newItem) {
        return this.http.postType("Statistics.Templates", "Create", {
            'Name': newItem.Name,
            'Description': newItem.Description,
            'Category': newItem.Category,
            'Query': newItem.Query
        })
            .pipe(
                tap((response) => {
                    super.refresh().subscribe(() => {
                    })
                    //super.add(newItem);
                })
            );
    }

    update(newItem) {
        return this.http.postType("Statistics.Templates", "Update", {
            'OldName': newItem.Name,
            'Name': newItem.Name,
            'Description': newItem.Description,
            'Category': newItem.Category,
            'Query': newItem.Query
        })
            .pipe(
                tap((response) => {
                    super.refresh().subscribe(() => {
                    });
                    //super.update(newItem);
                })
            );
    }

    deleteSelected() {
        var sendingObj = {};
        for (let i = 0; i < this.currentItems.length; i++) {
            if (this.currentItems[i]['selected']) {
            }
        }
        return this.http.postType("Statistics.Templates", "Delete", sendingObj)
            .pipe(
                switchMap(() => this.refresh())
            );
    }

    delete(item) {
        return this.http.postType("Statistics.Templates", "Delete", { Names: [item[this.colName]] })
            .pipe(
                switchMap(() => this.refresh())
            );
    }

    public clear() {
        return super.clear();
    }

    public reset() {
    }
}
